export const configCropper =  {
    aspectRatio:1/1
  };
